import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";
import { getClusterBySlug } from "@/lib/clusterMeta";

export const Route = createFileRoute("/_app/rates/$cluster")({
  head: ({ params }) => {
    const meta = getClusterBySlug(params.cluster);
    if (!meta) {
      return buildHead({
        title: "Scrap Metal Rates | LohaLink",
        description: "Live wholesale scrap metal rates across India.",
        canonical: `/rates/${params.cluster}`,
      });
    }
    const canonical = `https://lohalink.in/rates/${meta.slug}`;
    const jsonLdWebPage = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: `Today's Live Scrap Metal Rates in ${meta.name}`,
      description: `Live wholesale prices for HMS 1, HMS 2, sponge iron, MS billet and pig iron in ${meta.name}, ${meta.state}.`,
      url: canonical,
      mainEntity: {
        "@type": "Dataset",
        name: `${meta.name} scrap metal price index`,
        description: `Daily benchmarked ex-yard scrap and steel rates in ${meta.name}, ${meta.state}.`,
        keywords: [
          `scrap rate ${meta.name}`,
          `${meta.name} HMS 1 price`,
          `${meta.name} sponge iron rate`,
          `iron scrap price ${meta.name}`,
          "wholesale steel rates India",
        ].join(", "),
        spatialCoverage: { "@type": "Place", name: `${meta.name}, ${meta.state}, India` },
        creator: { "@type": "Organization", name: "LohaLink" },
      },
    };
    const jsonLdBreadcrumb = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://lohalink.in/" },
        { "@type": "ListItem", position: 2, name: "Live Rates", item: "https://lohalink.in/rates" },
        { "@type": "ListItem", position: 3, name: meta.name, item: canonical },
      ],
    };
    return buildHead({
      title: `Today's Verified Scrap Metal Rates in ${meta.name} | LohaLink`,
      description: `View live wholesale prices for HMS 1, HMS 2, and sponge iron in ${meta.name}. Track market changes and secure trades with RBI-grade escrow.`,
      canonical,
      jsonLd: [jsonLdWebPage, jsonLdBreadcrumb],
    });
  },
  component: lazyRouteComponent(() => import("@/pages/RatesCluster")),
});
